/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StatementDisplayStatus = {
    Outstanding: 'Outstanding',
    Paid: 'Paid',
    PartiallyPaid: 'PartiallyPaid',
    Applied: 'Applied',
    WrittenOff: 'WrittenOff',
    Adjusted: 'Adjusted',
    Charged: 'Charged',
    Refunded: 'Refunded',
    Pending: 'Pending',
    Reserved: 'Reserved',
    Declined: 'Declined',
    Settled: 'Settled',
    Voided: 'Voided',
    Unknown: 'Unknown'
} as const;
export type StatementDisplayStatus = typeof StatementDisplayStatus[keyof typeof StatementDisplayStatus];


export function instanceOfStatementDisplayStatus(value: any): boolean {
    for (const key in StatementDisplayStatus) {
        if (Object.prototype.hasOwnProperty.call(StatementDisplayStatus, key)) {
            if (StatementDisplayStatus[key as keyof typeof StatementDisplayStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatementDisplayStatusFromJSON(json: any): StatementDisplayStatus {
    return StatementDisplayStatusFromJSONTyped(json, false);
}

export function StatementDisplayStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementDisplayStatus {
    return json as StatementDisplayStatus;
}

export function StatementDisplayStatusToJSON(value?: StatementDisplayStatus | null): any {
    return value as any;
}

export function StatementDisplayStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StatementDisplayStatus {
    return value as StatementDisplayStatus;
}

